module.exports = __webpack_public_path__ + "img/team-1.b59c4187.jpg";